window.CustomStorage = {
    language: {
        get: () => window.localStorage.getItem('language'),
        set: (value) => window.localStorage.setItem('language', value),
    },
    country: {
        get: () => window.localStorage.getItem('country'),
        set: (value) => window.localStorage.setItem('country', value),
    },
};
